<template>
  <sdk-input @blur="onBlur" @focus="onFocus" @input="onInput" :maxlength="5" :style="inputStyle" :placeholder="placeholder" />
</template>
<script>
import SdkInput from '@/views/sdk/components/sdk-input.vue'
import { onExpiredDateInput, rules } from '@/utils/tools/checkout'
import { sendMessageToClient, getFormatMessage, encryptData } from '@/views/sdk/tools'

export default {
  name: 'card-date',
  components: { SdkInput },
  data() {
    return {
      inputValue: '',
      options: {},
      isError: false,
      inputStyle: {},
      placeholder: ''
    }
  },
  created() {
    window.addEventListener('message', this.listeningMessage)
  },
  methods: {
    listeningMessage(messageData) {
      const { event, data } = getFormatMessage(messageData, this.$route) || {}
      switch (event) {
        case 'sdk_checkout__settings': {
          this.options = data
          this.inputStyle = data?.inputStyle || {}
          this.placeholder = data?.inputPlaceholder?.expirationDate || ''
          break
        }
        case 'sdk_checkout__validator': {
          this.sendErrorMessage(this.inputValue)
          break
        }
        case 'sdk_checkout__date_collect': {
          if (!this.isError) {
            const dateArray = this.inputValue.split('/')
            sendMessageToClient(
              'sdk_checkout__date_prepare',
              {
                expiredYear: encryptData(dateArray[1], this.options?.verificationData?.key, this.options?.verificationData?.iv),
                expiredMonth: encryptData(dateArray[0], this.options?.verificationData?.key, this.options?.verificationData?.iv)
              },
              this.$route
            )
          } else {
            sendMessageToClient('sdk_checkout__date_prepare', { expiredYear: '', expiredMonth: '' }, this.$route)
          }
          break
        }
      }
    },
    sendErrorMessage(value) {
      rules.monthYear(null, value, (error, typeCode) => {
        this.isError = !!error
        if (this.isError) {
          sendMessageToClient('sdk_checkout__form_verify', { typeCode }, this.$route)
        } else {
          sendMessageToClient('sdk_checkout__form_verify', { typeCode: '15030' }, this.$route)
        }
      })
    },
    onInput(event) {
      event.target.value = onExpiredDateInput(event)
      this.inputValue = event.target.value
      if (this.options.errorTrigger === 'change') {
        this.sendErrorMessage(this.inputValue)
      }
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'expiration_date_change' }, this.$route)
    },
    onFocus() {
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'expiration_date_focus' }, this.$route)
    },
    onBlur() {
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'expiration_date_blur' }, this.$route)
      if (this.options.errorTrigger === 'blur') {
        this.sendErrorMessage(this.inputValue)
      }
    }
  },
  watch: {
    '$store.getters.app.currentLan': 'onLanguageChange'
  }
}
</script>
<style lang="less">
@import '~@/styles/common.less';
</style>
